import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ProgressService} from 'src/app/services/progress.service';
import {SessionService, UserType} from 'src/app/services/session.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  progress = 0;
  inProgress = false;
  message = null;
  loading = false;
  isDs = false;

  constructor(private sessionService: SessionService, private progressService: ProgressService, private router: Router) {
  }

  ngOnInit() {
    this.progressService.progressBar.subscribe(data => {
      this.inProgress = !data['inProgress'] ? false : true;
      this.message = data['message'];
      this.progress = data['progress'];
      this.loading = !data['loading'] ? false : true;
    });
    this.sessionService.userUpdate.subscribe(() => {
      this.isDs = true; // @todo (!this.sessionService.getUser().enterpriseId);
    });
  }

  gotoPrivacy() {
    this.router.navigateByUrl((this.isDs) ? 'privacy' : 'privacy-organisation');
  }

  gotoTransparency() {
    this.router.navigateByUrl('transparency');
  }

  gotoHome() {
    this.router.navigateByUrl('');
  }

  gotoTerms() {
    this.router.navigateByUrl((this.isDs) ? 'terms' : 'terms-organisation');
  }
}
